interface Product {
    id: string;
    name: string;
    units: string;
    price: string;
}

declare global {
    interface Window {
        _trboq: unknown[];
        rdssTracker: {
            pageDataState: {
                page: {
                    type: string;
                    name: string;
                };
                order: {
                    id: string;
                    totalPurchaseValue: string;
                };
                products: {
                    [key: string]: Product;
                };
                user?: {
                    gender: string;
                    status: string;
                    customerStreams: string;
                    isExistingCustomer: string;
                    payback: string;
                };
                checkout?: {
                    voucherCode: string;
                    voucherValue: string;
                };
            };
        };
    }
}

const pageTypeMapping = {
    'Startseite': 'home',
    'Produktkategorieseite': 'category',
    'Produktdetailseite': 'detail',
    'Suche': 'search',
    'Warenkorb': 'basket',
    'Checkout': 'checkout',
    'Kundenkonto': 'account',
    'Themenwelten': 'static',
};

/**
 * Get the page type for trbo.
 */
const getPageType = (page: {type: string, name: string}) => {
    if (page?.name === 'wf-de:checkout:finish') {
        return 'confirmation';
    }
    else if (page?.name.includes('wf-de:checkout:cart') || page?.name.includes('wf-de:checkout:addVoucher')) {
        return 'basket';
    }
    else if (page?.name.includes('wf-de:checkout:')) {
        return 'checkout';
    }
    else {
        return pageTypeMapping[page?.type] || 'other';
    }
};

/**
 * Format the products for trbo.
 */
const formatProducts = (products: {[key: string]: Product}) => Object.values(products).map((product) => {
    return {
        product_id: product.id,
        name: product.name,
        quantity: parseInt(product.units, 10),
        price: parseFloat(product.price),
    }
})

/**
 * Trbo service.
 */
const trboService = {
    init: () => {
        try {
            /* eslint-disable  @typescript-eslint/ban-ts-comment */
            // @ts-ignore
            const _trboq = window._trboq || _trboq || [];

            if (!window._trboq) {
                window._trboq = _trboq;
            }

            window._trboq.push(['page', {
                type: getPageType(window.rdssTracker?.pageDataState?.page),
            }]);

            if (window.rdssTracker?.pageDataState?.page?.name === 'wf-de:checkout:finish') {
                window._trboq.push(['sale', {
                    order_id: window.rdssTracker.pageDataState.order.id,
                    value: parseFloat(window.rdssTracker.pageDataState.order.totalPurchaseValue),
                    currency: 'EUR',
                    coupon_code: window.rdssTracker.pageDataState?.checkout?.voucherCode,
                    custom: {
                        gender: window.rdssTracker.pageDataState?.user?.gender,
                        customerStatus: window.rdssTracker.pageDataState?.user?.status,
                        customerStreams: window.rdssTracker.pageDataState?.user?.customerStreams,
                        isExistingCustomer: window.rdssTracker.pageDataState?.user?.isExistingCustomer,
                        payback: window.rdssTracker.pageDataState?.user?.payback,
                    },
                    products: formatProducts(window.rdssTracker.pageDataState.products),
                }]);
            }
        } catch (error) {
            console.error('Error initializing trbo:', error);
        }
    },
    trackAddToCart: (orderNumber: string, quantity: number) => {
        window?._trboq?.push(['basket',
            {
                currency: 'EUR',
                products: [{ product_id: orderNumber, quantity: quantity }],
            },
        ]);
    },
    trackCurrentBasket: (basketValue: string) => {
        let voucherValue = 0;
        if (window.rdssTracker?.pageDataState?.checkout?.voucherValue) {
            voucherValue = parseFloat(window.rdssTracker.pageDataState.checkout.voucherValue);
        }

        window?._trboq?.push(
            ['currentBasket', {
                value: parseFloat(basketValue),
                currency: 'EUR',
                voucher: voucherValue,
            }]);
    },
}

export default trboService
